/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeReconnectWindowDeletedDto,
  ApiEnvelopeReconnectWindowDto,
  ApiEnvelopeReconnectWindowListDto,
  ApiEnvelopeReconnectWindowStatusDto,
  CreateReconnectWindowRequest,
  UpdateReconnectWindowRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type reconnectWindowsAdminListWindowsResponse200 = {
  data: ApiEnvelopeReconnectWindowListDto
  status: 200
}

export type reconnectWindowsAdminListWindowsResponseSuccess = (reconnectWindowsAdminListWindowsResponse200) & {
  headers: Headers;
};
;

export type reconnectWindowsAdminListWindowsResponse = (reconnectWindowsAdminListWindowsResponseSuccess)

export const getReconnectWindowsAdminListWindowsUrl = () => {




  return `/api/admin/reconnect-windows`
}

export const useReconnectWindowsAdminListWindowsHook = (): ( options?: RequestInit) => Promise<reconnectWindowsAdminListWindowsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getReconnectWindowsAdminListWindowsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type reconnectWindowsAdminCreateWindowResponse200 = {
  data: ApiEnvelopeReconnectWindowDto
  status: 200
}

export type reconnectWindowsAdminCreateWindowResponse400 = {
  data: ApiEnvelopeReconnectWindowDto
  status: 400
}

export type reconnectWindowsAdminCreateWindowResponseSuccess = (reconnectWindowsAdminCreateWindowResponse200) & {
  headers: Headers;
};
export type reconnectWindowsAdminCreateWindowResponseError = (reconnectWindowsAdminCreateWindowResponse400) & {
  headers: Headers;
};

export type reconnectWindowsAdminCreateWindowResponse = (reconnectWindowsAdminCreateWindowResponseSuccess | reconnectWindowsAdminCreateWindowResponseError)

export const getReconnectWindowsAdminCreateWindowUrl = () => {




  return `/api/admin/reconnect-windows`
}

export const useReconnectWindowsAdminCreateWindowHook = (): (createReconnectWindowRequest?: CreateReconnectWindowRequest, options?: RequestInit) => Promise<reconnectWindowsAdminCreateWindowResponse> => {

      const customFetcher = useSfetchMutator();
      return (createReconnectWindowRequest?: CreateReconnectWindowRequest, options?: RequestInit) => {

        return customFetcher(getReconnectWindowsAdminCreateWindowUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createReconnectWindowRequest)
  }
);
      }
  }


export type reconnectWindowsAdminGetStatusResponse200 = {
  data: ApiEnvelopeReconnectWindowStatusDto
  status: 200
}

export type reconnectWindowsAdminGetStatusResponseSuccess = (reconnectWindowsAdminGetStatusResponse200) & {
  headers: Headers;
};
;

export type reconnectWindowsAdminGetStatusResponse = (reconnectWindowsAdminGetStatusResponseSuccess)

export const getReconnectWindowsAdminGetStatusUrl = () => {




  return `/api/admin/reconnect-windows/status`
}

export const useReconnectWindowsAdminGetStatusHook = (): ( options?: RequestInit) => Promise<reconnectWindowsAdminGetStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getReconnectWindowsAdminGetStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type reconnectWindowsAdminUpdateWindowResponse200 = {
  data: ApiEnvelopeReconnectWindowDto
  status: 200
}

export type reconnectWindowsAdminUpdateWindowResponse400 = {
  data: ApiEnvelopeReconnectWindowDto
  status: 400
}

export type reconnectWindowsAdminUpdateWindowResponse404 = {
  data: ApiEnvelopeReconnectWindowDto
  status: 404
}

export type reconnectWindowsAdminUpdateWindowResponseSuccess = (reconnectWindowsAdminUpdateWindowResponse200) & {
  headers: Headers;
};
export type reconnectWindowsAdminUpdateWindowResponseError = (reconnectWindowsAdminUpdateWindowResponse400 | reconnectWindowsAdminUpdateWindowResponse404) & {
  headers: Headers;
};

export type reconnectWindowsAdminUpdateWindowResponse = (reconnectWindowsAdminUpdateWindowResponseSuccess | reconnectWindowsAdminUpdateWindowResponseError)

export const getReconnectWindowsAdminUpdateWindowUrl = (id: string,) => {




  return `/api/admin/reconnect-windows/${id}`
}

export const useReconnectWindowsAdminUpdateWindowHook = (): (id: string,
    updateReconnectWindowRequest?: UpdateReconnectWindowRequest, options?: RequestInit) => Promise<reconnectWindowsAdminUpdateWindowResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    updateReconnectWindowRequest?: UpdateReconnectWindowRequest, options?: RequestInit) => {

        return customFetcher(getReconnectWindowsAdminUpdateWindowUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateReconnectWindowRequest)
  }
);
      }
  }


export type reconnectWindowsAdminDeleteWindowResponse200 = {
  data: ApiEnvelopeReconnectWindowDeletedDto
  status: 200
}

export type reconnectWindowsAdminDeleteWindowResponse404 = {
  data: ApiEnvelopeReconnectWindowDeletedDto
  status: 404
}

export type reconnectWindowsAdminDeleteWindowResponseSuccess = (reconnectWindowsAdminDeleteWindowResponse200) & {
  headers: Headers;
};
export type reconnectWindowsAdminDeleteWindowResponseError = (reconnectWindowsAdminDeleteWindowResponse404) & {
  headers: Headers;
};

export type reconnectWindowsAdminDeleteWindowResponse = (reconnectWindowsAdminDeleteWindowResponseSuccess | reconnectWindowsAdminDeleteWindowResponseError)

export const getReconnectWindowsAdminDeleteWindowUrl = (id: string,) => {




  return `/api/admin/reconnect-windows/${id}`
}

export const useReconnectWindowsAdminDeleteWindowHook = (): (id: string, options?: RequestInit) => Promise<reconnectWindowsAdminDeleteWindowResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getReconnectWindowsAdminDeleteWindowUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


